import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import classNames from 'classnames';
import { string } from 'yup';
import { SelectField, TextField } from 'Components';
import preferenceOptions from 'constants/preferenceOptions';
import './EmailNotificationsTemplate.css';

const EmailNotificationsTemplate = ({
  Company,
  ReportAddress,
  ReportingTo,
  ProjectNumber,
  ProjectName,
  NotifyJobReceived,
  NotifyJobReported,
  NotifyExcedence,
  NotifyJobReceivedEmail,
  NotifyJobReportedEmail,
  NotifyExcedenceEmail,
  onEmailChange,
  onPreferenceChange,
  tableIndex,
}) => {
  const translatedPreferenceOptions = preferenceOptions.map(item => ({
    label: i18n.t(`emailNotifications:${item.label}`),
    value: item.value,
  }));

  const validEmail = string().email('Invalid email format. Note, only one email address can be populated in this field.');

  return (
    <tr className="email-notifications-template">
      <td>
        <div className="email-notifications-template__scenario">
          <div><strong>{i18n.t('emailNotifications:Company')}:</strong><span>{Company}</span></div>
          <div><strong>{i18n.t('emailNotifications:Report To')}:</strong><span>{ReportAddress}</span></div>
          <div><strong>{i18n.t('emailNotifications:Attention')}:</strong><span>{ReportingTo}</span></div>
          <div><strong>{i18n.t('emailNotifications:Project')}:</strong><span>{ProjectNumber}</span></div>
          <div><strong>{i18n.t('emailNotifications:Site')}:</strong><span>{ProjectName}</span></div>
        </div>
      </td>
      <td>
        <div className="email-notifications-template__notification">
          <div>{i18n.t('emailNotifications:Job Received')}</div>
          <div>{i18n.t('emailNotifications:Job Reported')}</div>
          <div>{i18n.t('emailNotifications:Exceedance')}</div>
        </div>
      </td>
      <td>
        <div className="email-notifications-template__preference">
          <SelectField
            value={NotifyJobReceived}
            options={translatedPreferenceOptions}
            onChange={e => onPreferenceChange(e, tableIndex, 'NotifyJobReceived')}
          />
          <SelectField
            value={NotifyJobReported}
            options={translatedPreferenceOptions}
            onChange={e => onPreferenceChange(e, tableIndex, 'NotifyJobReported')}
          />
          <SelectField
            value={NotifyExcedence}
            options={translatedPreferenceOptions}
            onChange={e => onPreferenceChange(e, tableIndex, 'NotifyExcedence')}
          />
        </div>
      </td>
      <td>
        <div className="email-notifications-template__emails">
          <TextField
            className={classNames({
              'email-notifications-template__emails--hidden': NotifyJobReceived !== 2,
            })}
            value={NotifyJobReceivedEmail}
            hasError={!validEmail.isValidSync(NotifyJobReceivedEmail) || NotifyJobReceivedEmail === ''}
            onChange={e => onEmailChange(e, tableIndex, 'NotifyJobReceivedEmail')}
            type="email"
          />
          <TextField
            className={classNames({
              'email-notifications-template__emails--hidden': NotifyJobReported !== 2,
            })}
            value={NotifyJobReportedEmail}
            hasError={!validEmail.isValidSync(NotifyJobReportedEmail) || NotifyJobReportedEmail === ''}
            onChange={e => onEmailChange(e, tableIndex, 'NotifyJobReportedEmail')}
            type="email"
          />
          <TextField
            className={classNames({
              'email-notifications-template__emails--hidden': NotifyExcedence !== 2,
            })}
            value={NotifyExcedenceEmail}
            hasError={!validEmail.isValidSync(NotifyExcedenceEmail) || NotifyExcedenceEmail === ''}
            onChange={e => onEmailChange(e, tableIndex, 'NotifyExcedenceEmail')}
            type="email"
          />
        </div>
      </td>
    </tr>
  );
};

EmailNotificationsTemplate.propTypes = {
  Company: PropTypes.string,
  ReportAddress: PropTypes.string,
  ReportingTo: PropTypes.string,
  ProjectNumber: PropTypes.string,
  ProjectName: PropTypes.string,
  NotifyJobReceived: PropTypes.oneOf([0, 1, 2]),
  NotifyJobReported: PropTypes.oneOf([0, 1, 2]),
  NotifyExcedence: PropTypes.oneOf([0, 1, 2]),
  NotifyJobReceivedEmail: PropTypes.string,
  NotifyJobReportedEmail: PropTypes.string,
  NotifyExcedenceEmail: PropTypes.string,
  tableIndex: PropTypes.number,
  onEmailChange: PropTypes.func,
  onPreferenceChange: PropTypes.func,
};

export default EmailNotificationsTemplate;



// WEBPACK FOOTER //
// ./src/components/EmailNotificationsTemplate/EmailNotificationsTemplate.jsx